import { useTranslation } from "react-i18next"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { raiseToast } from "shared/lib/toast/raiseToast"
import { useEvent } from "shared/lib/useEvent"
import { ApolloFetchPolicy } from "shared/types/ApolloFetchPolicy"
import { ToastType } from "shared/types/Toast"

import { useAttachmentEntitiesQuery } from "entities/attachments/api/useAttachmentEntitiesQuery"
import { LinkedAttachmentEntity } from "entities/attachments/ui/linked-attachments/types/LinkedAttachmentEntity"
import { useDeleteProjectAttachment } from "entities/projects/api/useDeleteProjectAttachment"

import { DeleteAttachmentOverlayModel } from "../DeleteAttachmentOverlay"
import { DeleteAttachmentOverlayConnectorProps } from "../DeleteAttachmentOverlayConnector"

export function useDeleteAttachmentOverlayModel({
  payload
}: DeleteAttachmentOverlayConnectorProps): DeleteAttachmentOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { t } = useTranslation()
  const { deleteProjectAttachment } = useDeleteProjectAttachment()

  const handleDelete = useEvent(async () => {
    await deleteProjectAttachment(
      { id: payload.attachment.id },
      payload.projectID
    )
    raiseToast({
      message: t("Request.Attachments.DELETE_ATTACHMENT.Success"),
      type: ToastType.SUCCESS
    })
    closeOverlay()
  })

  const { data } = useAttachmentEntitiesQuery({
    id: payload.attachment.id,
    fetchPolicy: ApolloFetchPolicy.NETWORK_ONLY
  })

  return {
    payload,
    linkedEntities: data?.attachmentEntities?.entities as
      | LinkedAttachmentEntity[]
      | null
      | undefined,
    onDelete: handleDelete,
    onClose: closeOverlay
  }
}
